<template>
  <div :class="{'modal-open':isSomeModalOpen,'filters-open':showFilters}">
    <div class="fixed-part">
      <page-header @mounted="useFixedPart"></page-header>
    </div>

    <b-container fluid class="outer">
      <div class="action-holder">
        <b-btn @click="addItem" variant="primary">New</b-btn>
      </div>

      <b-tabs class="campaign-tabs mt-0" @input="tabChange">
        <b-tab title="In production" active>
          <campaigns-table :finished="false" />
        </b-tab>
        <b-tab title="Past campaigns">
          <past-campaigns-table />
        </b-tab>
      </b-tabs>

    </b-container>

    <b-container fluid class="outer"><server-processing :serverIsBusy="dataLoading"/></b-container>
    <campaign-card ref="newCampaign"
                   @done="campaignsInit"
    ></campaign-card>
  </div>

</template>

<script>
import fixedHeader from '../_mixins/fixed-header.js';

export default {
  components: {
    'page-header': () => import('@/components/Header.vue'),
    'value-item': () => import('@/components/ValueItem.vue'),
    'campaign-card': () => import('@/components/CampaignCard.vue'),
    'campaigns-table': () => import('@/components/CampaignsTable.vue'),
    'past-campaigns-table': () => import('@/components/PastCampaignsTable.vue'),
  },
  mixins: [fixedHeader],
  props: {
    client_id: {
      type: Number
    }
  },
  data: () => ({
    selectedPage: 1,
    totalPages: 1,
    rowsPerPage: 20,
    URLsListLoading: false,
    URLsList: [],
    showFilters: false,
    filters: {},
    fixedPart: null,
    fixedPartHeight: 0,
  }),
  methods: {
    tabChange(tabNum) {
      if (tabNum===0) {
        // this.$store.dispatch('campaigns/getAll');
      } else if (tabNum===1) {
        // this.$store.dispatch('campaigns/getPast');
      }
    },
    addItem() {
      this.$refs.newCampaign.show();
    },
    campaignsInit() {
      this.$store.dispatch('campaigns/getAll');
      this.$store.dispatch('campaigns/getPast');
    },
  },
  computed: {
    isSomeModalOpen() {
      return false;
    },
    dataLoading() {
      return this.$store.state.campaigns.serverProcessing || false;
    },
    user() {
      return this.$store.state.authentication.user;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';
@import '../assets/_scss/components/action-panel';
@import '../assets/_scss/components/campaign-tabs';

.action-holder {
  padding: 15px 0;
}
</style>
